/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { DATA_SERVICES } from './services';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
})
export class BuilderSharedDataModule {
  static forRoot(): ModuleWithProviders<BuilderSharedDataModule> {
    return {
      ngModule: BuilderSharedDataModule,
      providers: DATA_SERVICES,
    };
  }

  static forChild(): ModuleWithProviders<BuilderSharedDataModule> {
    return {
      ngModule: BuilderSharedDataModule,
      providers: [],
    };
  }
}
